import React from 'react';
import '@aws-amplify/ui-react/styles.css';
import {
  View, Flex, Text, Heading, TextField, Button, Card, Image
} from "@aws-amplify/ui-react";
import { StorageImage } from '@aws-amplify/ui-react-storage';

const Question = ({ question, index, handleAnswer, answers }) => {
  return (
      <Card>
    <div className={`question-container`} >
      <h3>Question {index + 1}</h3>
      <p>{question.question}</p>
      { question.image_name && (
        <StorageImage
            height="200px"
            alt={question.question}
            path={ `protected/${question.image_name}.png`}
            // path="protected/${question.image_name}"
        />
      )}




      <ul>
        {question.possible_answers.map((response, i) => (
          <li key={i}>
            <input
              type="radio"
              name={`response-${index}`}
              value={response}
              checked={answers[index] === response}
              onChange={() => handleAnswer(index, response)}
            />
            <label>{response}</label>
          </li>
        ))}
      </ul>
    </div>
      </Card>
  );
};

export default Question;
